/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendAdvancedProductDto } from '../models/backend-advanced-product-dto';
import { BackendAdvancedProductConversionFieldDto } from '../models/backend-advanced-product-conversion-field-dto';
import { BackendIdDto } from '../models/backend-id-dto';
import { BackendPaginatedTabularProductDataListDto } from '../models/backend-paginated-tabular-product-data-list-dto';
import { BackendProductGroupDto } from '../models/backend-product-group-dto';
import { BackendProductVariantDto } from '../models/backend-product-variant-dto';
import { salesAdvancedProductConversionFieldsCreate } from '../fn/products/sales-advanced-product-conversion-fields-create';
import { salesAdvancedProductConversionFieldsCreate$FormData } from '../fn/products/sales-advanced-product-conversion-fields-create-form-data';
import { SalesAdvancedProductConversionFieldsCreate$FormData$Params } from '../fn/products/sales-advanced-product-conversion-fields-create-form-data';
import { SalesAdvancedProductConversionFieldsCreate$Params } from '../fn/products/sales-advanced-product-conversion-fields-create';
import { salesAdvancedProductConversionFieldsCreate$XWwwFormUrlencoded } from '../fn/products/sales-advanced-product-conversion-fields-create-x-www-form-urlencoded';
import { SalesAdvancedProductConversionFieldsCreate$XWwwFormUrlencoded$Params } from '../fn/products/sales-advanced-product-conversion-fields-create-x-www-form-urlencoded';
import { salesAdvancedProductConversionFieldsDestroy } from '../fn/products/sales-advanced-product-conversion-fields-destroy';
import { SalesAdvancedProductConversionFieldsDestroy$Params } from '../fn/products/sales-advanced-product-conversion-fields-destroy';
import { salesAdvancedProductConversionFieldsList } from '../fn/products/sales-advanced-product-conversion-fields-list';
import { SalesAdvancedProductConversionFieldsList$Params } from '../fn/products/sales-advanced-product-conversion-fields-list';
import { salesAdvancedProductConversionFieldsPartialUpdate } from '../fn/products/sales-advanced-product-conversion-fields-partial-update';
import { salesAdvancedProductConversionFieldsPartialUpdate$FormData } from '../fn/products/sales-advanced-product-conversion-fields-partial-update-form-data';
import { SalesAdvancedProductConversionFieldsPartialUpdate$FormData$Params } from '../fn/products/sales-advanced-product-conversion-fields-partial-update-form-data';
import { SalesAdvancedProductConversionFieldsPartialUpdate$Params } from '../fn/products/sales-advanced-product-conversion-fields-partial-update';
import { salesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded } from '../fn/products/sales-advanced-product-conversion-fields-partial-update-x-www-form-urlencoded';
import { SalesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-advanced-product-conversion-fields-partial-update-x-www-form-urlencoded';
import { salesAdvancedProductConversionFieldsRetrieve } from '../fn/products/sales-advanced-product-conversion-fields-retrieve';
import { SalesAdvancedProductConversionFieldsRetrieve$Params } from '../fn/products/sales-advanced-product-conversion-fields-retrieve';
import { salesAdvancedProductConversionFieldsUpdate } from '../fn/products/sales-advanced-product-conversion-fields-update';
import { salesAdvancedProductConversionFieldsUpdate$FormData } from '../fn/products/sales-advanced-product-conversion-fields-update-form-data';
import { SalesAdvancedProductConversionFieldsUpdate$FormData$Params } from '../fn/products/sales-advanced-product-conversion-fields-update-form-data';
import { SalesAdvancedProductConversionFieldsUpdate$Params } from '../fn/products/sales-advanced-product-conversion-fields-update';
import { salesAdvancedProductConversionFieldsUpdate$XWwwFormUrlencoded } from '../fn/products/sales-advanced-product-conversion-fields-update-x-www-form-urlencoded';
import { SalesAdvancedProductConversionFieldsUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-advanced-product-conversion-fields-update-x-www-form-urlencoded';
import { salesAdvancedProductsCopyCreate } from '../fn/products/sales-advanced-products-copy-create';
import { SalesAdvancedProductsCopyCreate$Params } from '../fn/products/sales-advanced-products-copy-create';
import { salesAdvancedProductsCreate } from '../fn/products/sales-advanced-products-create';
import { salesAdvancedProductsCreate$FormData } from '../fn/products/sales-advanced-products-create-form-data';
import { SalesAdvancedProductsCreate$FormData$Params } from '../fn/products/sales-advanced-products-create-form-data';
import { SalesAdvancedProductsCreate$Params } from '../fn/products/sales-advanced-products-create';
import { salesAdvancedProductsCreate$XWwwFormUrlencoded } from '../fn/products/sales-advanced-products-create-x-www-form-urlencoded';
import { SalesAdvancedProductsCreate$XWwwFormUrlencoded$Params } from '../fn/products/sales-advanced-products-create-x-www-form-urlencoded';
import { salesAdvancedProductsDestroy } from '../fn/products/sales-advanced-products-destroy';
import { SalesAdvancedProductsDestroy$Params } from '../fn/products/sales-advanced-products-destroy';
import { salesAdvancedProductsList } from '../fn/products/sales-advanced-products-list';
import { SalesAdvancedProductsList$Params } from '../fn/products/sales-advanced-products-list';
import { salesAdvancedProductsPartialUpdate } from '../fn/products/sales-advanced-products-partial-update';
import { salesAdvancedProductsPartialUpdate$FormData } from '../fn/products/sales-advanced-products-partial-update-form-data';
import { SalesAdvancedProductsPartialUpdate$FormData$Params } from '../fn/products/sales-advanced-products-partial-update-form-data';
import { SalesAdvancedProductsPartialUpdate$Params } from '../fn/products/sales-advanced-products-partial-update';
import { salesAdvancedProductsPartialUpdate$XWwwFormUrlencoded } from '../fn/products/sales-advanced-products-partial-update-x-www-form-urlencoded';
import { SalesAdvancedProductsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-advanced-products-partial-update-x-www-form-urlencoded';
import { salesAdvancedProductsRetrieve } from '../fn/products/sales-advanced-products-retrieve';
import { SalesAdvancedProductsRetrieve$Params } from '../fn/products/sales-advanced-products-retrieve';
import { salesAdvancedProductsUpdate } from '../fn/products/sales-advanced-products-update';
import { salesAdvancedProductsUpdate$FormData } from '../fn/products/sales-advanced-products-update-form-data';
import { SalesAdvancedProductsUpdate$FormData$Params } from '../fn/products/sales-advanced-products-update-form-data';
import { SalesAdvancedProductsUpdate$Params } from '../fn/products/sales-advanced-products-update';
import { salesAdvancedProductsUpdate$XWwwFormUrlencoded } from '../fn/products/sales-advanced-products-update-x-www-form-urlencoded';
import { SalesAdvancedProductsUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-advanced-products-update-x-www-form-urlencoded';
import { salesGroupsCreate } from '../fn/products/sales-groups-create';
import { salesGroupsCreate$FormData } from '../fn/products/sales-groups-create-form-data';
import { SalesGroupsCreate$FormData$Params } from '../fn/products/sales-groups-create-form-data';
import { SalesGroupsCreate$Params } from '../fn/products/sales-groups-create';
import { salesGroupsCreate$XWwwFormUrlencoded } from '../fn/products/sales-groups-create-x-www-form-urlencoded';
import { SalesGroupsCreate$XWwwFormUrlencoded$Params } from '../fn/products/sales-groups-create-x-www-form-urlencoded';
import { salesGroupsDestroy } from '../fn/products/sales-groups-destroy';
import { SalesGroupsDestroy$Params } from '../fn/products/sales-groups-destroy';
import { salesGroupsList } from '../fn/products/sales-groups-list';
import { SalesGroupsList$Params } from '../fn/products/sales-groups-list';
import { salesGroupsPartialUpdate } from '../fn/products/sales-groups-partial-update';
import { salesGroupsPartialUpdate$FormData } from '../fn/products/sales-groups-partial-update-form-data';
import { SalesGroupsPartialUpdate$FormData$Params } from '../fn/products/sales-groups-partial-update-form-data';
import { SalesGroupsPartialUpdate$Params } from '../fn/products/sales-groups-partial-update';
import { salesGroupsPartialUpdate$XWwwFormUrlencoded } from '../fn/products/sales-groups-partial-update-x-www-form-urlencoded';
import { SalesGroupsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-groups-partial-update-x-www-form-urlencoded';
import { salesGroupsRetrieve } from '../fn/products/sales-groups-retrieve';
import { SalesGroupsRetrieve$Params } from '../fn/products/sales-groups-retrieve';
import { salesGroupsUpdate } from '../fn/products/sales-groups-update';
import { salesGroupsUpdate$FormData } from '../fn/products/sales-groups-update-form-data';
import { SalesGroupsUpdate$FormData$Params } from '../fn/products/sales-groups-update-form-data';
import { SalesGroupsUpdate$Params } from '../fn/products/sales-groups-update';
import { salesGroupsUpdate$XWwwFormUrlencoded } from '../fn/products/sales-groups-update-x-www-form-urlencoded';
import { SalesGroupsUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-groups-update-x-www-form-urlencoded';
import { salesProductsEnumsRetrieve } from '../fn/products/sales-products-enums-retrieve';
import { SalesProductsEnumsRetrieve$Params } from '../fn/products/sales-products-enums-retrieve';
import { salesProductVariantsCopyCreate } from '../fn/products/sales-product-variants-copy-create';
import { SalesProductVariantsCopyCreate$Params } from '../fn/products/sales-product-variants-copy-create';
import { salesProductVariantsCreate } from '../fn/products/sales-product-variants-create';
import { salesProductVariantsCreate$FormData } from '../fn/products/sales-product-variants-create-form-data';
import { SalesProductVariantsCreate$FormData$Params } from '../fn/products/sales-product-variants-create-form-data';
import { SalesProductVariantsCreate$Params } from '../fn/products/sales-product-variants-create';
import { salesProductVariantsCreate$XWwwFormUrlencoded } from '../fn/products/sales-product-variants-create-x-www-form-urlencoded';
import { SalesProductVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/products/sales-product-variants-create-x-www-form-urlencoded';
import { salesProductVariantsDestroy } from '../fn/products/sales-product-variants-destroy';
import { SalesProductVariantsDestroy$Params } from '../fn/products/sales-product-variants-destroy';
import { salesProductVariantsList } from '../fn/products/sales-product-variants-list';
import { SalesProductVariantsList$Params } from '../fn/products/sales-product-variants-list';
import { salesProductVariantsPartialUpdate } from '../fn/products/sales-product-variants-partial-update';
import { salesProductVariantsPartialUpdate$FormData } from '../fn/products/sales-product-variants-partial-update-form-data';
import { SalesProductVariantsPartialUpdate$FormData$Params } from '../fn/products/sales-product-variants-partial-update-form-data';
import { SalesProductVariantsPartialUpdate$Params } from '../fn/products/sales-product-variants-partial-update';
import { salesProductVariantsPartialUpdate$XWwwFormUrlencoded } from '../fn/products/sales-product-variants-partial-update-x-www-form-urlencoded';
import { SalesProductVariantsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-product-variants-partial-update-x-www-form-urlencoded';
import { salesProductVariantsRetrieve } from '../fn/products/sales-product-variants-retrieve';
import { SalesProductVariantsRetrieve$Params } from '../fn/products/sales-product-variants-retrieve';
import { salesProductVariantsUpdate } from '../fn/products/sales-product-variants-update';
import { salesProductVariantsUpdate$FormData } from '../fn/products/sales-product-variants-update-form-data';
import { SalesProductVariantsUpdate$FormData$Params } from '../fn/products/sales-product-variants-update-form-data';
import { SalesProductVariantsUpdate$Params } from '../fn/products/sales-product-variants-update';
import { salesProductVariantsUpdate$XWwwFormUrlencoded } from '../fn/products/sales-product-variants-update-x-www-form-urlencoded';
import { SalesProductVariantsUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-product-variants-update-x-www-form-urlencoded';
import { salesSpreadsheetRetrieve } from '../fn/products/sales-spreadsheet-retrieve';
import { SalesSpreadsheetRetrieve$Params } from '../fn/products/sales-spreadsheet-retrieve';
import { salesSpreadsheetUpdate } from '../fn/products/sales-spreadsheet-update';
import { salesSpreadsheetUpdate$FormData } from '../fn/products/sales-spreadsheet-update-form-data';
import { SalesSpreadsheetUpdate$FormData$Params } from '../fn/products/sales-spreadsheet-update-form-data';
import { SalesSpreadsheetUpdate$Params } from '../fn/products/sales-spreadsheet-update';
import { salesSpreadsheetUpdate$XWwwFormUrlencoded } from '../fn/products/sales-spreadsheet-update-x-www-form-urlencoded';
import { SalesSpreadsheetUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-spreadsheet-update-x-www-form-urlencoded';
import { salesStandardProductConversionFieldsDestroy } from '../fn/products/sales-standard-product-conversion-fields-destroy';
import { SalesStandardProductConversionFieldsDestroy$Params } from '../fn/products/sales-standard-product-conversion-fields-destroy';
import { salesStandardProductConversionFieldsPartialUpdate } from '../fn/products/sales-standard-product-conversion-fields-partial-update';
import { salesStandardProductConversionFieldsPartialUpdate$FormData } from '../fn/products/sales-standard-product-conversion-fields-partial-update-form-data';
import { SalesStandardProductConversionFieldsPartialUpdate$FormData$Params } from '../fn/products/sales-standard-product-conversion-fields-partial-update-form-data';
import { SalesStandardProductConversionFieldsPartialUpdate$Params } from '../fn/products/sales-standard-product-conversion-fields-partial-update';
import { salesStandardProductConversionFieldsPartialUpdate$XWwwFormUrlencoded } from '../fn/products/sales-standard-product-conversion-fields-partial-update-x-www-form-urlencoded';
import { SalesStandardProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-standard-product-conversion-fields-partial-update-x-www-form-urlencoded';
import { salesStandardProductConversionFieldsRetrieve } from '../fn/products/sales-standard-product-conversion-fields-retrieve';
import { SalesStandardProductConversionFieldsRetrieve$Params } from '../fn/products/sales-standard-product-conversion-fields-retrieve';
import { salesStandardProductConversionFieldsUpdate } from '../fn/products/sales-standard-product-conversion-fields-update';
import { salesStandardProductConversionFieldsUpdate$FormData } from '../fn/products/sales-standard-product-conversion-fields-update-form-data';
import { SalesStandardProductConversionFieldsUpdate$FormData$Params } from '../fn/products/sales-standard-product-conversion-fields-update-form-data';
import { SalesStandardProductConversionFieldsUpdate$Params } from '../fn/products/sales-standard-product-conversion-fields-update';
import { salesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded } from '../fn/products/sales-standard-product-conversion-fields-update-x-www-form-urlencoded';
import { SalesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-standard-product-conversion-fields-update-x-www-form-urlencoded';
import { salesStandardProductsCopyCreate } from '../fn/products/sales-standard-products-copy-create';
import { SalesStandardProductsCopyCreate$Params } from '../fn/products/sales-standard-products-copy-create';
import { salesStandardProductsCreate } from '../fn/products/sales-standard-products-create';
import { salesStandardProductsCreate$FormData } from '../fn/products/sales-standard-products-create-form-data';
import { SalesStandardProductsCreate$FormData$Params } from '../fn/products/sales-standard-products-create-form-data';
import { SalesStandardProductsCreate$Params } from '../fn/products/sales-standard-products-create';
import { salesStandardProductsCreate$XWwwFormUrlencoded } from '../fn/products/sales-standard-products-create-x-www-form-urlencoded';
import { SalesStandardProductsCreate$XWwwFormUrlencoded$Params } from '../fn/products/sales-standard-products-create-x-www-form-urlencoded';
import { salesStandardProductsDestroy } from '../fn/products/sales-standard-products-destroy';
import { SalesStandardProductsDestroy$Params } from '../fn/products/sales-standard-products-destroy';
import { salesStandardProductsList } from '../fn/products/sales-standard-products-list';
import { SalesStandardProductsList$Params } from '../fn/products/sales-standard-products-list';
import { salesStandardProductsPartialUpdate } from '../fn/products/sales-standard-products-partial-update';
import { salesStandardProductsPartialUpdate$FormData } from '../fn/products/sales-standard-products-partial-update-form-data';
import { SalesStandardProductsPartialUpdate$FormData$Params } from '../fn/products/sales-standard-products-partial-update-form-data';
import { SalesStandardProductsPartialUpdate$Params } from '../fn/products/sales-standard-products-partial-update';
import { salesStandardProductsPartialUpdate$XWwwFormUrlencoded } from '../fn/products/sales-standard-products-partial-update-x-www-form-urlencoded';
import { SalesStandardProductsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-standard-products-partial-update-x-www-form-urlencoded';
import { salesStandardProductsRetrieve } from '../fn/products/sales-standard-products-retrieve';
import { SalesStandardProductsRetrieve$Params } from '../fn/products/sales-standard-products-retrieve';
import { salesStandardProductsUpdate } from '../fn/products/sales-standard-products-update';
import { salesStandardProductsUpdate$FormData } from '../fn/products/sales-standard-products-update-form-data';
import { SalesStandardProductsUpdate$FormData$Params } from '../fn/products/sales-standard-products-update-form-data';
import { SalesStandardProductsUpdate$Params } from '../fn/products/sales-standard-products-update';
import { salesStandardProductsUpdate$XWwwFormUrlencoded } from '../fn/products/sales-standard-products-update-x-www-form-urlencoded';
import { SalesStandardProductsUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-standard-products-update-x-www-form-urlencoded';
import { salesTabularProductsCreate } from '../fn/products/sales-tabular-products-create';
import { salesTabularProductsCreate$FormData } from '../fn/products/sales-tabular-products-create-form-data';
import { SalesTabularProductsCreate$FormData$Params } from '../fn/products/sales-tabular-products-create-form-data';
import { SalesTabularProductsCreate$Params } from '../fn/products/sales-tabular-products-create';
import { salesTabularProductsCreate$XWwwFormUrlencoded } from '../fn/products/sales-tabular-products-create-x-www-form-urlencoded';
import { SalesTabularProductsCreate$XWwwFormUrlencoded$Params } from '../fn/products/sales-tabular-products-create-x-www-form-urlencoded';
import { salesTabularProductsDataList } from '../fn/products/sales-tabular-products-data-list';
import { SalesTabularProductsDataList$Params } from '../fn/products/sales-tabular-products-data-list';
import { salesTabularProductsDataUpdate } from '../fn/products/sales-tabular-products-data-update';
import { salesTabularProductsDataUpdate$FormData } from '../fn/products/sales-tabular-products-data-update-form-data';
import { SalesTabularProductsDataUpdate$FormData$Params } from '../fn/products/sales-tabular-products-data-update-form-data';
import { SalesTabularProductsDataUpdate$Params } from '../fn/products/sales-tabular-products-data-update';
import { salesTabularProductsDataUpdate$XWwwFormUrlencoded } from '../fn/products/sales-tabular-products-data-update-x-www-form-urlencoded';
import { SalesTabularProductsDataUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-tabular-products-data-update-x-www-form-urlencoded';
import { salesTabularProductsDestroy } from '../fn/products/sales-tabular-products-destroy';
import { SalesTabularProductsDestroy$Params } from '../fn/products/sales-tabular-products-destroy';
import { salesTabularProductsList } from '../fn/products/sales-tabular-products-list';
import { SalesTabularProductsList$Params } from '../fn/products/sales-tabular-products-list';
import { salesTabularProductsPartialUpdate } from '../fn/products/sales-tabular-products-partial-update';
import { salesTabularProductsPartialUpdate$FormData } from '../fn/products/sales-tabular-products-partial-update-form-data';
import { SalesTabularProductsPartialUpdate$FormData$Params } from '../fn/products/sales-tabular-products-partial-update-form-data';
import { SalesTabularProductsPartialUpdate$Params } from '../fn/products/sales-tabular-products-partial-update';
import { salesTabularProductsPartialUpdate$XWwwFormUrlencoded } from '../fn/products/sales-tabular-products-partial-update-x-www-form-urlencoded';
import { SalesTabularProductsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-tabular-products-partial-update-x-www-form-urlencoded';
import { salesTabularProductsRetrieve } from '../fn/products/sales-tabular-products-retrieve';
import { SalesTabularProductsRetrieve$Params } from '../fn/products/sales-tabular-products-retrieve';
import { salesTabularProductsUpdate } from '../fn/products/sales-tabular-products-update';
import { salesTabularProductsUpdate$FormData } from '../fn/products/sales-tabular-products-update-form-data';
import { SalesTabularProductsUpdate$FormData$Params } from '../fn/products/sales-tabular-products-update-form-data';
import { SalesTabularProductsUpdate$Params } from '../fn/products/sales-tabular-products-update';
import { salesTabularProductsUpdate$XWwwFormUrlencoded } from '../fn/products/sales-tabular-products-update-x-www-form-urlencoded';
import { SalesTabularProductsUpdate$XWwwFormUrlencoded$Params } from '../fn/products/sales-tabular-products-update-x-www-form-urlencoded';
import { salesUnblockProductsVariantsCreate } from '../fn/products/sales-unblock-products-variants-create';
import { salesUnblockProductsVariantsCreate$FormData } from '../fn/products/sales-unblock-products-variants-create-form-data';
import { SalesUnblockProductsVariantsCreate$FormData$Params } from '../fn/products/sales-unblock-products-variants-create-form-data';
import { SalesUnblockProductsVariantsCreate$Params } from '../fn/products/sales-unblock-products-variants-create';
import { salesUnblockProductsVariantsCreate$XWwwFormUrlencoded } from '../fn/products/sales-unblock-products-variants-create-x-www-form-urlencoded';
import { SalesUnblockProductsVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/products/sales-unblock-products-variants-create-x-www-form-urlencoded';
import { BackendSpreadsheetConfigDto } from '../models/backend-spreadsheet-config-dto';
import { BackendStandardProductDto } from '../models/backend-standard-product-dto';
import { BackendStandartProductConversionFieldDto } from '../models/backend-standart-product-conversion-field-dto';
import { BackendTabularProductDto } from '../models/backend-tabular-product-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiProductsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `salesAdvancedProductConversionFieldsList()` */
  static readonly SalesAdvancedProductConversionFieldsListPath = '/api/sales/advanced-product-conversion-fields/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductConversionFieldsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductConversionFieldsList$Response(
    params?: SalesAdvancedProductConversionFieldsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendAdvancedProductConversionFieldDto>>> {
    return salesAdvancedProductConversionFieldsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductConversionFieldsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductConversionFieldsList(
    params?: SalesAdvancedProductConversionFieldsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendAdvancedProductConversionFieldDto>> {
    return this.salesAdvancedProductConversionFieldsList$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<Array<BackendAdvancedProductConversionFieldDto>>,
        ): Array<BackendAdvancedProductConversionFieldDto> => r.body,
      ),
    );
  }

  /** Path part for operation `salesAdvancedProductConversionFieldsCreate()` */
  static readonly SalesAdvancedProductConversionFieldsCreatePath = '/api/sales/advanced-product-conversion-fields/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductConversionFieldsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesAdvancedProductConversionFieldsCreate$Response(
    params: SalesAdvancedProductConversionFieldsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
    return salesAdvancedProductConversionFieldsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductConversionFieldsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesAdvancedProductConversionFieldsCreate(
    params: SalesAdvancedProductConversionFieldsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductConversionFieldDto> {
    return this.salesAdvancedProductConversionFieldsCreate$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendAdvancedProductConversionFieldDto>): BackendAdvancedProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductConversionFieldsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesAdvancedProductConversionFieldsCreate$XWwwFormUrlencoded$Response(
    params: SalesAdvancedProductConversionFieldsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
    return salesAdvancedProductConversionFieldsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductConversionFieldsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesAdvancedProductConversionFieldsCreate$XWwwFormUrlencoded(
    params: SalesAdvancedProductConversionFieldsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductConversionFieldDto> {
    return this.salesAdvancedProductConversionFieldsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendAdvancedProductConversionFieldDto>): BackendAdvancedProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductConversionFieldsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesAdvancedProductConversionFieldsCreate$FormData$Response(
    params: SalesAdvancedProductConversionFieldsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
    return salesAdvancedProductConversionFieldsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductConversionFieldsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesAdvancedProductConversionFieldsCreate$FormData(
    params: SalesAdvancedProductConversionFieldsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductConversionFieldDto> {
    return this.salesAdvancedProductConversionFieldsCreate$FormData$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendAdvancedProductConversionFieldDto>): BackendAdvancedProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /** Path part for operation `salesAdvancedProductConversionFieldsRetrieve()` */
  static readonly SalesAdvancedProductConversionFieldsRetrievePath =
    '/api/sales/advanced-product-conversion-fields/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductConversionFieldsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductConversionFieldsRetrieve$Response(
    params: SalesAdvancedProductConversionFieldsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
    return salesAdvancedProductConversionFieldsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductConversionFieldsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductConversionFieldsRetrieve(
    params: SalesAdvancedProductConversionFieldsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductConversionFieldDto> {
    return this.salesAdvancedProductConversionFieldsRetrieve$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendAdvancedProductConversionFieldDto>): BackendAdvancedProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /** Path part for operation `salesAdvancedProductConversionFieldsUpdate()` */
  static readonly SalesAdvancedProductConversionFieldsUpdatePath =
    '/api/sales/advanced-product-conversion-fields/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductConversionFieldsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesAdvancedProductConversionFieldsUpdate$Response(
    params: SalesAdvancedProductConversionFieldsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
    return salesAdvancedProductConversionFieldsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductConversionFieldsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesAdvancedProductConversionFieldsUpdate(
    params: SalesAdvancedProductConversionFieldsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductConversionFieldDto> {
    return this.salesAdvancedProductConversionFieldsUpdate$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendAdvancedProductConversionFieldDto>): BackendAdvancedProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductConversionFieldsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesAdvancedProductConversionFieldsUpdate$XWwwFormUrlencoded$Response(
    params: SalesAdvancedProductConversionFieldsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
    return salesAdvancedProductConversionFieldsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductConversionFieldsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesAdvancedProductConversionFieldsUpdate$XWwwFormUrlencoded(
    params: SalesAdvancedProductConversionFieldsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductConversionFieldDto> {
    return this.salesAdvancedProductConversionFieldsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendAdvancedProductConversionFieldDto>): BackendAdvancedProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductConversionFieldsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesAdvancedProductConversionFieldsUpdate$FormData$Response(
    params: SalesAdvancedProductConversionFieldsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
    return salesAdvancedProductConversionFieldsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductConversionFieldsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesAdvancedProductConversionFieldsUpdate$FormData(
    params: SalesAdvancedProductConversionFieldsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductConversionFieldDto> {
    return this.salesAdvancedProductConversionFieldsUpdate$FormData$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendAdvancedProductConversionFieldDto>): BackendAdvancedProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /** Path part for operation `salesAdvancedProductConversionFieldsDestroy()` */
  static readonly SalesAdvancedProductConversionFieldsDestroyPath =
    '/api/sales/advanced-product-conversion-fields/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductConversionFieldsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductConversionFieldsDestroy$Response(
    params: SalesAdvancedProductConversionFieldsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesAdvancedProductConversionFieldsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductConversionFieldsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductConversionFieldsDestroy(
    params: SalesAdvancedProductConversionFieldsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.salesAdvancedProductConversionFieldsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesAdvancedProductConversionFieldsPartialUpdate()` */
  static readonly SalesAdvancedProductConversionFieldsPartialUpdatePath =
    '/api/sales/advanced-product-conversion-fields/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductConversionFieldsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesAdvancedProductConversionFieldsPartialUpdate$Response(
    params: SalesAdvancedProductConversionFieldsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
    return salesAdvancedProductConversionFieldsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductConversionFieldsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesAdvancedProductConversionFieldsPartialUpdate(
    params: SalesAdvancedProductConversionFieldsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductConversionFieldDto> {
    return this.salesAdvancedProductConversionFieldsPartialUpdate$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendAdvancedProductConversionFieldDto>): BackendAdvancedProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Response(
    params: SalesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
    return salesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded(
      this.http,
      this.rootUrl,
      params,
      context,
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded(
    params: SalesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductConversionFieldDto> {
    return this.salesAdvancedProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendAdvancedProductConversionFieldDto>): BackendAdvancedProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductConversionFieldsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesAdvancedProductConversionFieldsPartialUpdate$FormData$Response(
    params: SalesAdvancedProductConversionFieldsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
    return salesAdvancedProductConversionFieldsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductConversionFieldsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesAdvancedProductConversionFieldsPartialUpdate$FormData(
    params: SalesAdvancedProductConversionFieldsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductConversionFieldDto> {
    return this.salesAdvancedProductConversionFieldsPartialUpdate$FormData$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendAdvancedProductConversionFieldDto>): BackendAdvancedProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /** Path part for operation `salesAdvancedProductsList()` */
  static readonly SalesAdvancedProductsListPath = '/api/sales/advanced-products/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductsList$Response(
    params?: SalesAdvancedProductsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendAdvancedProductDto>>> {
    return salesAdvancedProductsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductsList(
    params?: SalesAdvancedProductsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendAdvancedProductDto>> {
    return this.salesAdvancedProductsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendAdvancedProductDto>>): Array<BackendAdvancedProductDto> => r.body),
    );
  }

  /** Path part for operation `salesAdvancedProductsCreate()` */
  static readonly SalesAdvancedProductsCreatePath = '/api/sales/advanced-products/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesAdvancedProductsCreate$Response(
    params?: SalesAdvancedProductsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
    return salesAdvancedProductsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesAdvancedProductsCreate(
    params?: SalesAdvancedProductsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductDto> {
    return this.salesAdvancedProductsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendAdvancedProductDto>): BackendAdvancedProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesAdvancedProductsCreate$XWwwFormUrlencoded$Response(
    params?: SalesAdvancedProductsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
    return salesAdvancedProductsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesAdvancedProductsCreate$XWwwFormUrlencoded(
    params?: SalesAdvancedProductsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductDto> {
    return this.salesAdvancedProductsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendAdvancedProductDto>): BackendAdvancedProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesAdvancedProductsCreate$FormData$Response(
    params?: SalesAdvancedProductsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
    return salesAdvancedProductsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesAdvancedProductsCreate$FormData(
    params?: SalesAdvancedProductsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductDto> {
    return this.salesAdvancedProductsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendAdvancedProductDto>): BackendAdvancedProductDto => r.body),
    );
  }

  /** Path part for operation `salesAdvancedProductsRetrieve()` */
  static readonly SalesAdvancedProductsRetrievePath = '/api/sales/advanced-products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductsRetrieve$Response(
    params: SalesAdvancedProductsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
    return salesAdvancedProductsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductsRetrieve(
    params: SalesAdvancedProductsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductDto> {
    return this.salesAdvancedProductsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendAdvancedProductDto>): BackendAdvancedProductDto => r.body),
    );
  }

  /** Path part for operation `salesAdvancedProductsUpdate()` */
  static readonly SalesAdvancedProductsUpdatePath = '/api/sales/advanced-products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesAdvancedProductsUpdate$Response(
    params: SalesAdvancedProductsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
    return salesAdvancedProductsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesAdvancedProductsUpdate(
    params: SalesAdvancedProductsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductDto> {
    return this.salesAdvancedProductsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendAdvancedProductDto>): BackendAdvancedProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesAdvancedProductsUpdate$XWwwFormUrlencoded$Response(
    params: SalesAdvancedProductsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
    return salesAdvancedProductsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesAdvancedProductsUpdate$XWwwFormUrlencoded(
    params: SalesAdvancedProductsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductDto> {
    return this.salesAdvancedProductsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendAdvancedProductDto>): BackendAdvancedProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesAdvancedProductsUpdate$FormData$Response(
    params: SalesAdvancedProductsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
    return salesAdvancedProductsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesAdvancedProductsUpdate$FormData(
    params: SalesAdvancedProductsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductDto> {
    return this.salesAdvancedProductsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendAdvancedProductDto>): BackendAdvancedProductDto => r.body),
    );
  }

  /** Path part for operation `salesAdvancedProductsDestroy()` */
  static readonly SalesAdvancedProductsDestroyPath = '/api/sales/advanced-products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductsDestroy$Response(
    params: SalesAdvancedProductsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesAdvancedProductsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductsDestroy(params: SalesAdvancedProductsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.salesAdvancedProductsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesAdvancedProductsPartialUpdate()` */
  static readonly SalesAdvancedProductsPartialUpdatePath = '/api/sales/advanced-products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesAdvancedProductsPartialUpdate$Response(
    params: SalesAdvancedProductsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
    return salesAdvancedProductsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesAdvancedProductsPartialUpdate(
    params: SalesAdvancedProductsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductDto> {
    return this.salesAdvancedProductsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendAdvancedProductDto>): BackendAdvancedProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesAdvancedProductsPartialUpdate$XWwwFormUrlencoded$Response(
    params: SalesAdvancedProductsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
    return salesAdvancedProductsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesAdvancedProductsPartialUpdate$XWwwFormUrlencoded(
    params: SalesAdvancedProductsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductDto> {
    return this.salesAdvancedProductsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendAdvancedProductDto>): BackendAdvancedProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesAdvancedProductsPartialUpdate$FormData$Response(
    params: SalesAdvancedProductsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendAdvancedProductDto>> {
    return salesAdvancedProductsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesAdvancedProductsPartialUpdate$FormData(
    params: SalesAdvancedProductsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendAdvancedProductDto> {
    return this.salesAdvancedProductsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendAdvancedProductDto>): BackendAdvancedProductDto => r.body),
    );
  }

  /** Path part for operation `salesAdvancedProductsCopyCreate()` */
  static readonly SalesAdvancedProductsCopyCreatePath = '/api/sales/advanced-products/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesAdvancedProductsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductsCopyCreate$Response(
    params: SalesAdvancedProductsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesAdvancedProductsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesAdvancedProductsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesAdvancedProductsCopyCreate(
    params: SalesAdvancedProductsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.salesAdvancedProductsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesGroupsList()` */
  static readonly SalesGroupsListPath = '/api/sales/groups/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesGroupsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesGroupsList$Response(
    params?: SalesGroupsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendProductGroupDto>>> {
    return salesGroupsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesGroupsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesGroupsList(params?: SalesGroupsList$Params, context?: HttpContext): Observable<Array<BackendProductGroupDto>> {
    return this.salesGroupsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendProductGroupDto>>): Array<BackendProductGroupDto> => r.body),
    );
  }

  /** Path part for operation `salesGroupsCreate()` */
  static readonly SalesGroupsCreatePath = '/api/sales/groups/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesGroupsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesGroupsCreate$Response(
    params: SalesGroupsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductGroupDto>> {
    return salesGroupsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesGroupsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesGroupsCreate(params: SalesGroupsCreate$Params, context?: HttpContext): Observable<BackendProductGroupDto> {
    return this.salesGroupsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductGroupDto>): BackendProductGroupDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesGroupsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesGroupsCreate$XWwwFormUrlencoded$Response(
    params: SalesGroupsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductGroupDto>> {
    return salesGroupsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesGroupsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesGroupsCreate$XWwwFormUrlencoded(
    params: SalesGroupsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProductGroupDto> {
    return this.salesGroupsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductGroupDto>): BackendProductGroupDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesGroupsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesGroupsCreate$FormData$Response(
    params: SalesGroupsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductGroupDto>> {
    return salesGroupsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesGroupsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesGroupsCreate$FormData(
    params: SalesGroupsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProductGroupDto> {
    return this.salesGroupsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductGroupDto>): BackendProductGroupDto => r.body),
    );
  }

  /** Path part for operation `salesGroupsRetrieve()` */
  static readonly SalesGroupsRetrievePath = '/api/sales/groups/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesGroupsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesGroupsRetrieve$Response(
    params: SalesGroupsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductGroupDto>> {
    return salesGroupsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesGroupsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesGroupsRetrieve(params: SalesGroupsRetrieve$Params, context?: HttpContext): Observable<BackendProductGroupDto> {
    return this.salesGroupsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductGroupDto>): BackendProductGroupDto => r.body),
    );
  }

  /** Path part for operation `salesGroupsUpdate()` */
  static readonly SalesGroupsUpdatePath = '/api/sales/groups/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesGroupsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesGroupsUpdate$Response(
    params: SalesGroupsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductGroupDto>> {
    return salesGroupsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesGroupsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesGroupsUpdate(params: SalesGroupsUpdate$Params, context?: HttpContext): Observable<BackendProductGroupDto> {
    return this.salesGroupsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductGroupDto>): BackendProductGroupDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesGroupsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesGroupsUpdate$XWwwFormUrlencoded$Response(
    params: SalesGroupsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductGroupDto>> {
    return salesGroupsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesGroupsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesGroupsUpdate$XWwwFormUrlencoded(
    params: SalesGroupsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProductGroupDto> {
    return this.salesGroupsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductGroupDto>): BackendProductGroupDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesGroupsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesGroupsUpdate$FormData$Response(
    params: SalesGroupsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductGroupDto>> {
    return salesGroupsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesGroupsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesGroupsUpdate$FormData(
    params: SalesGroupsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProductGroupDto> {
    return this.salesGroupsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductGroupDto>): BackendProductGroupDto => r.body),
    );
  }

  /** Path part for operation `salesGroupsDestroy()` */
  static readonly SalesGroupsDestroyPath = '/api/sales/groups/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesGroupsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesGroupsDestroy$Response(
    params: SalesGroupsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesGroupsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesGroupsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesGroupsDestroy(params: SalesGroupsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.salesGroupsDestroy$Response(params, context).pipe(map((r: BakendHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `salesGroupsPartialUpdate()` */
  static readonly SalesGroupsPartialUpdatePath = '/api/sales/groups/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesGroupsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesGroupsPartialUpdate$Response(
    params: SalesGroupsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductGroupDto>> {
    return salesGroupsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesGroupsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesGroupsPartialUpdate(
    params: SalesGroupsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendProductGroupDto> {
    return this.salesGroupsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductGroupDto>): BackendProductGroupDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesGroupsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesGroupsPartialUpdate$XWwwFormUrlencoded$Response(
    params: SalesGroupsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductGroupDto>> {
    return salesGroupsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesGroupsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesGroupsPartialUpdate$XWwwFormUrlencoded(
    params: SalesGroupsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProductGroupDto> {
    return this.salesGroupsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductGroupDto>): BackendProductGroupDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesGroupsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesGroupsPartialUpdate$FormData$Response(
    params: SalesGroupsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductGroupDto>> {
    return salesGroupsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesGroupsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesGroupsPartialUpdate$FormData(
    params: SalesGroupsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProductGroupDto> {
    return this.salesGroupsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductGroupDto>): BackendProductGroupDto => r.body),
    );
  }

  /** Path part for operation `salesProductVariantsList()` */
  static readonly SalesProductVariantsListPath = '/api/sales/product_variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesProductVariantsList$Response(
    params?: SalesProductVariantsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendProductVariantDto>>> {
    return salesProductVariantsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesProductVariantsList(
    params?: SalesProductVariantsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendProductVariantDto>> {
    return this.salesProductVariantsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendProductVariantDto>>): Array<BackendProductVariantDto> => r.body),
    );
  }

  /** Path part for operation `salesProductVariantsCreate()` */
  static readonly SalesProductVariantsCreatePath = '/api/sales/product_variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesProductVariantsCreate$Response(
    params: SalesProductVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductVariantDto>> {
    return salesProductVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesProductVariantsCreate(
    params: SalesProductVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendProductVariantDto> {
    return this.salesProductVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductVariantDto>): BackendProductVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesProductVariantsCreate$XWwwFormUrlencoded$Response(
    params: SalesProductVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductVariantDto>> {
    return salesProductVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesProductVariantsCreate$XWwwFormUrlencoded(
    params: SalesProductVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProductVariantDto> {
    return this.salesProductVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductVariantDto>): BackendProductVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesProductVariantsCreate$FormData$Response(
    params: SalesProductVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductVariantDto>> {
    return salesProductVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesProductVariantsCreate$FormData(
    params: SalesProductVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProductVariantDto> {
    return this.salesProductVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductVariantDto>): BackendProductVariantDto => r.body),
    );
  }

  /** Path part for operation `salesProductVariantsRetrieve()` */
  static readonly SalesProductVariantsRetrievePath = '/api/sales/product_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesProductVariantsRetrieve$Response(
    params: SalesProductVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductVariantDto>> {
    return salesProductVariantsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesProductVariantsRetrieve(
    params: SalesProductVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendProductVariantDto> {
    return this.salesProductVariantsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductVariantDto>): BackendProductVariantDto => r.body),
    );
  }

  /** Path part for operation `salesProductVariantsUpdate()` */
  static readonly SalesProductVariantsUpdatePath = '/api/sales/product_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesProductVariantsUpdate$Response(
    params: SalesProductVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductVariantDto>> {
    return salesProductVariantsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesProductVariantsUpdate(
    params: SalesProductVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendProductVariantDto> {
    return this.salesProductVariantsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductVariantDto>): BackendProductVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesProductVariantsUpdate$XWwwFormUrlencoded$Response(
    params: SalesProductVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductVariantDto>> {
    return salesProductVariantsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesProductVariantsUpdate$XWwwFormUrlencoded(
    params: SalesProductVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProductVariantDto> {
    return this.salesProductVariantsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductVariantDto>): BackendProductVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesProductVariantsUpdate$FormData$Response(
    params: SalesProductVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductVariantDto>> {
    return salesProductVariantsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesProductVariantsUpdate$FormData(
    params: SalesProductVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProductVariantDto> {
    return this.salesProductVariantsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductVariantDto>): BackendProductVariantDto => r.body),
    );
  }

  /** Path part for operation `salesProductVariantsDestroy()` */
  static readonly SalesProductVariantsDestroyPath = '/api/sales/product_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesProductVariantsDestroy$Response(
    params: SalesProductVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesProductVariantsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesProductVariantsDestroy(params: SalesProductVariantsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.salesProductVariantsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesProductVariantsPartialUpdate()` */
  static readonly SalesProductVariantsPartialUpdatePath = '/api/sales/product_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesProductVariantsPartialUpdate$Response(
    params: SalesProductVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductVariantDto>> {
    return salesProductVariantsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesProductVariantsPartialUpdate(
    params: SalesProductVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendProductVariantDto> {
    return this.salesProductVariantsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductVariantDto>): BackendProductVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesProductVariantsPartialUpdate$XWwwFormUrlencoded$Response(
    params: SalesProductVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductVariantDto>> {
    return salesProductVariantsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesProductVariantsPartialUpdate$XWwwFormUrlencoded(
    params: SalesProductVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProductVariantDto> {
    return this.salesProductVariantsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductVariantDto>): BackendProductVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesProductVariantsPartialUpdate$FormData$Response(
    params: SalesProductVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductVariantDto>> {
    return salesProductVariantsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesProductVariantsPartialUpdate$FormData(
    params: SalesProductVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProductVariantDto> {
    return this.salesProductVariantsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductVariantDto>): BackendProductVariantDto => r.body),
    );
  }

  /** Path part for operation `salesProductVariantsCopyCreate()` */
  static readonly SalesProductVariantsCopyCreatePath = '/api/sales/product_variants/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductVariantsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesProductVariantsCopyCreate$Response(
    params: SalesProductVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesProductVariantsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductVariantsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesProductVariantsCopyCreate(
    params: SalesProductVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.salesProductVariantsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesProductsEnumsRetrieve()` */
  static readonly SalesProductsEnumsRetrievePath = '/api/sales/products/enums/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesProductsEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesProductsEnumsRetrieve$Response(
    params: SalesProductsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesProductsEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesProductsEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesProductsEnumsRetrieve(params: SalesProductsEnumsRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.salesProductsEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesSpreadsheetRetrieve()` */
  static readonly SalesSpreadsheetRetrievePath = '/api/sales/spreadsheet/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesSpreadsheetRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesSpreadsheetRetrieve$Response(
    params: SalesSpreadsheetRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSpreadsheetConfigDto>> {
    return salesSpreadsheetRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesSpreadsheetRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesSpreadsheetRetrieve(
    params: SalesSpreadsheetRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendSpreadsheetConfigDto> {
    return this.salesSpreadsheetRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSpreadsheetConfigDto>): BackendSpreadsheetConfigDto => r.body),
    );
  }

  /** Path part for operation `salesSpreadsheetUpdate()` */
  static readonly SalesSpreadsheetUpdatePath = '/api/sales/spreadsheet/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesSpreadsheetUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesSpreadsheetUpdate$Response(
    params: SalesSpreadsheetUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSpreadsheetConfigDto>> {
    return salesSpreadsheetUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesSpreadsheetUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesSpreadsheetUpdate(
    params: SalesSpreadsheetUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendSpreadsheetConfigDto> {
    return this.salesSpreadsheetUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSpreadsheetConfigDto>): BackendSpreadsheetConfigDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesSpreadsheetUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesSpreadsheetUpdate$XWwwFormUrlencoded$Response(
    params: SalesSpreadsheetUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSpreadsheetConfigDto>> {
    return salesSpreadsheetUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesSpreadsheetUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesSpreadsheetUpdate$XWwwFormUrlencoded(
    params: SalesSpreadsheetUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendSpreadsheetConfigDto> {
    return this.salesSpreadsheetUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSpreadsheetConfigDto>): BackendSpreadsheetConfigDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesSpreadsheetUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesSpreadsheetUpdate$FormData$Response(
    params: SalesSpreadsheetUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendSpreadsheetConfigDto>> {
    return salesSpreadsheetUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesSpreadsheetUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesSpreadsheetUpdate$FormData(
    params: SalesSpreadsheetUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendSpreadsheetConfigDto> {
    return this.salesSpreadsheetUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendSpreadsheetConfigDto>): BackendSpreadsheetConfigDto => r.body),
    );
  }

  /** Path part for operation `salesStandardProductConversionFieldsRetrieve()` */
  static readonly SalesStandardProductConversionFieldsRetrievePath =
    '/api/sales/standard-product-conversion-fields/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductConversionFieldsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductConversionFieldsRetrieve$Response(
    params: SalesStandardProductConversionFieldsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
    return salesStandardProductConversionFieldsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductConversionFieldsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductConversionFieldsRetrieve(
    params: SalesStandardProductConversionFieldsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendStandartProductConversionFieldDto> {
    return this.salesStandardProductConversionFieldsRetrieve$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendStandartProductConversionFieldDto>): BackendStandartProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /** Path part for operation `salesStandardProductConversionFieldsUpdate()` */
  static readonly SalesStandardProductConversionFieldsUpdatePath =
    '/api/sales/standard-product-conversion-fields/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductConversionFieldsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesStandardProductConversionFieldsUpdate$Response(
    params: SalesStandardProductConversionFieldsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
    return salesStandardProductConversionFieldsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductConversionFieldsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesStandardProductConversionFieldsUpdate(
    params: SalesStandardProductConversionFieldsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendStandartProductConversionFieldDto> {
    return this.salesStandardProductConversionFieldsUpdate$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendStandartProductConversionFieldDto>): BackendStandartProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded$Response(
    params: SalesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
    return salesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded(
    params: SalesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendStandartProductConversionFieldDto> {
    return this.salesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendStandartProductConversionFieldDto>): BackendStandartProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductConversionFieldsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesStandardProductConversionFieldsUpdate$FormData$Response(
    params: SalesStandardProductConversionFieldsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
    return salesStandardProductConversionFieldsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductConversionFieldsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesStandardProductConversionFieldsUpdate$FormData(
    params: SalesStandardProductConversionFieldsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendStandartProductConversionFieldDto> {
    return this.salesStandardProductConversionFieldsUpdate$FormData$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendStandartProductConversionFieldDto>): BackendStandartProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /** Path part for operation `salesStandardProductConversionFieldsDestroy()` */
  static readonly SalesStandardProductConversionFieldsDestroyPath =
    '/api/sales/standard-product-conversion-fields/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductConversionFieldsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductConversionFieldsDestroy$Response(
    params: SalesStandardProductConversionFieldsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesStandardProductConversionFieldsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductConversionFieldsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductConversionFieldsDestroy(
    params: SalesStandardProductConversionFieldsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.salesStandardProductConversionFieldsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesStandardProductConversionFieldsPartialUpdate()` */
  static readonly SalesStandardProductConversionFieldsPartialUpdatePath =
    '/api/sales/standard-product-conversion-fields/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductConversionFieldsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesStandardProductConversionFieldsPartialUpdate$Response(
    params: SalesStandardProductConversionFieldsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
    return salesStandardProductConversionFieldsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductConversionFieldsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesStandardProductConversionFieldsPartialUpdate(
    params: SalesStandardProductConversionFieldsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendStandartProductConversionFieldDto> {
    return this.salesStandardProductConversionFieldsPartialUpdate$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendStandartProductConversionFieldDto>): BackendStandartProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductConversionFieldsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesStandardProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Response(
    params: SalesStandardProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
    return salesStandardProductConversionFieldsPartialUpdate$XWwwFormUrlencoded(
      this.http,
      this.rootUrl,
      params,
      context,
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesStandardProductConversionFieldsPartialUpdate$XWwwFormUrlencoded(
    params: SalesStandardProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendStandartProductConversionFieldDto> {
    return this.salesStandardProductConversionFieldsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendStandartProductConversionFieldDto>): BackendStandartProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductConversionFieldsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesStandardProductConversionFieldsPartialUpdate$FormData$Response(
    params: SalesStandardProductConversionFieldsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
    return salesStandardProductConversionFieldsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductConversionFieldsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesStandardProductConversionFieldsPartialUpdate$FormData(
    params: SalesStandardProductConversionFieldsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendStandartProductConversionFieldDto> {
    return this.salesStandardProductConversionFieldsPartialUpdate$FormData$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendStandartProductConversionFieldDto>): BackendStandartProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /** Path part for operation `salesStandardProductsList()` */
  static readonly SalesStandardProductsListPath = '/api/sales/standard-products/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductsList$Response(
    params?: SalesStandardProductsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendStandardProductDto>>> {
    return salesStandardProductsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductsList(
    params?: SalesStandardProductsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendStandardProductDto>> {
    return this.salesStandardProductsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendStandardProductDto>>): Array<BackendStandardProductDto> => r.body),
    );
  }

  /** Path part for operation `salesStandardProductsCreate()` */
  static readonly SalesStandardProductsCreatePath = '/api/sales/standard-products/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesStandardProductsCreate$Response(
    params?: SalesStandardProductsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandardProductDto>> {
    return salesStandardProductsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesStandardProductsCreate(
    params?: SalesStandardProductsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendStandardProductDto> {
    return this.salesStandardProductsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendStandardProductDto>): BackendStandardProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesStandardProductsCreate$XWwwFormUrlencoded$Response(
    params?: SalesStandardProductsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandardProductDto>> {
    return salesStandardProductsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesStandardProductsCreate$XWwwFormUrlencoded(
    params?: SalesStandardProductsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendStandardProductDto> {
    return this.salesStandardProductsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendStandardProductDto>): BackendStandardProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesStandardProductsCreate$FormData$Response(
    params?: SalesStandardProductsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandardProductDto>> {
    return salesStandardProductsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesStandardProductsCreate$FormData(
    params?: SalesStandardProductsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendStandardProductDto> {
    return this.salesStandardProductsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendStandardProductDto>): BackendStandardProductDto => r.body),
    );
  }

  /** Path part for operation `salesStandardProductsRetrieve()` */
  static readonly SalesStandardProductsRetrievePath = '/api/sales/standard-products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductsRetrieve$Response(
    params: SalesStandardProductsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandardProductDto>> {
    return salesStandardProductsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductsRetrieve(
    params: SalesStandardProductsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendStandardProductDto> {
    return this.salesStandardProductsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendStandardProductDto>): BackendStandardProductDto => r.body),
    );
  }

  /** Path part for operation `salesStandardProductsUpdate()` */
  static readonly SalesStandardProductsUpdatePath = '/api/sales/standard-products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesStandardProductsUpdate$Response(
    params: SalesStandardProductsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandardProductDto>> {
    return salesStandardProductsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesStandardProductsUpdate(
    params: SalesStandardProductsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendStandardProductDto> {
    return this.salesStandardProductsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendStandardProductDto>): BackendStandardProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesStandardProductsUpdate$XWwwFormUrlencoded$Response(
    params: SalesStandardProductsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandardProductDto>> {
    return salesStandardProductsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesStandardProductsUpdate$XWwwFormUrlencoded(
    params: SalesStandardProductsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendStandardProductDto> {
    return this.salesStandardProductsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendStandardProductDto>): BackendStandardProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesStandardProductsUpdate$FormData$Response(
    params: SalesStandardProductsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandardProductDto>> {
    return salesStandardProductsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesStandardProductsUpdate$FormData(
    params: SalesStandardProductsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendStandardProductDto> {
    return this.salesStandardProductsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendStandardProductDto>): BackendStandardProductDto => r.body),
    );
  }

  /** Path part for operation `salesStandardProductsDestroy()` */
  static readonly SalesStandardProductsDestroyPath = '/api/sales/standard-products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductsDestroy$Response(
    params: SalesStandardProductsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesStandardProductsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductsDestroy(params: SalesStandardProductsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.salesStandardProductsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesStandardProductsPartialUpdate()` */
  static readonly SalesStandardProductsPartialUpdatePath = '/api/sales/standard-products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesStandardProductsPartialUpdate$Response(
    params: SalesStandardProductsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandardProductDto>> {
    return salesStandardProductsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesStandardProductsPartialUpdate(
    params: SalesStandardProductsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendStandardProductDto> {
    return this.salesStandardProductsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendStandardProductDto>): BackendStandardProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesStandardProductsPartialUpdate$XWwwFormUrlencoded$Response(
    params: SalesStandardProductsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandardProductDto>> {
    return salesStandardProductsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesStandardProductsPartialUpdate$XWwwFormUrlencoded(
    params: SalesStandardProductsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendStandardProductDto> {
    return this.salesStandardProductsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendStandardProductDto>): BackendStandardProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesStandardProductsPartialUpdate$FormData$Response(
    params: SalesStandardProductsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandardProductDto>> {
    return salesStandardProductsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesStandardProductsPartialUpdate$FormData(
    params: SalesStandardProductsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendStandardProductDto> {
    return this.salesStandardProductsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendStandardProductDto>): BackendStandardProductDto => r.body),
    );
  }

  /** Path part for operation `salesStandardProductsCopyCreate()` */
  static readonly SalesStandardProductsCopyCreatePath = '/api/sales/standard-products/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductsCopyCreate$Response(
    params: SalesStandardProductsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesStandardProductsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductsCopyCreate(
    params: SalesStandardProductsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.salesStandardProductsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesTabularProductsList()` */
  static readonly SalesTabularProductsListPath = '/api/sales/tabular-products/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesTabularProductsList$Response(
    params?: SalesTabularProductsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendTabularProductDto>>> {
    return salesTabularProductsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesTabularProductsList(
    params?: SalesTabularProductsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendTabularProductDto>> {
    return this.salesTabularProductsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendTabularProductDto>>): Array<BackendTabularProductDto> => r.body),
    );
  }

  /** Path part for operation `salesTabularProductsCreate()` */
  static readonly SalesTabularProductsCreatePath = '/api/sales/tabular-products/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesTabularProductsCreate$Response(
    params?: SalesTabularProductsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTabularProductDto>> {
    return salesTabularProductsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesTabularProductsCreate(
    params?: SalesTabularProductsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendTabularProductDto> {
    return this.salesTabularProductsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTabularProductDto>): BackendTabularProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesTabularProductsCreate$XWwwFormUrlencoded$Response(
    params?: SalesTabularProductsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTabularProductDto>> {
    return salesTabularProductsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesTabularProductsCreate$XWwwFormUrlencoded(
    params?: SalesTabularProductsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTabularProductDto> {
    return this.salesTabularProductsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTabularProductDto>): BackendTabularProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesTabularProductsCreate$FormData$Response(
    params?: SalesTabularProductsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTabularProductDto>> {
    return salesTabularProductsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesTabularProductsCreate$FormData(
    params?: SalesTabularProductsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTabularProductDto> {
    return this.salesTabularProductsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTabularProductDto>): BackendTabularProductDto => r.body),
    );
  }

  /** Path part for operation `salesTabularProductsDataList()` */
  static readonly SalesTabularProductsDataListPath = '/api/sales/tabular-products-data/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsDataList()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesTabularProductsDataList$Response(
    params: SalesTabularProductsDataList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedTabularProductDataListDto>> {
    return salesTabularProductsDataList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsDataList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesTabularProductsDataList(
    params: SalesTabularProductsDataList$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedTabularProductDataListDto> {
    return this.salesTabularProductsDataList$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendPaginatedTabularProductDataListDto>): BackendPaginatedTabularProductDataListDto =>
          r.body,
      ),
    );
  }

  /** Path part for operation `salesTabularProductsDataUpdate()` */
  static readonly SalesTabularProductsDataUpdatePath = '/api/sales/tabular-products-data/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsDataUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesTabularProductsDataUpdate$Response(
    params: SalesTabularProductsDataUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedTabularProductDataListDto>> {
    return salesTabularProductsDataUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsDataUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesTabularProductsDataUpdate(
    params: SalesTabularProductsDataUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedTabularProductDataListDto> {
    return this.salesTabularProductsDataUpdate$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendPaginatedTabularProductDataListDto>): BackendPaginatedTabularProductDataListDto =>
          r.body,
      ),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsDataUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesTabularProductsDataUpdate$XWwwFormUrlencoded$Response(
    params: SalesTabularProductsDataUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedTabularProductDataListDto>> {
    return salesTabularProductsDataUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsDataUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesTabularProductsDataUpdate$XWwwFormUrlencoded(
    params: SalesTabularProductsDataUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedTabularProductDataListDto> {
    return this.salesTabularProductsDataUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendPaginatedTabularProductDataListDto>): BackendPaginatedTabularProductDataListDto =>
          r.body,
      ),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsDataUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesTabularProductsDataUpdate$FormData$Response(
    params: SalesTabularProductsDataUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedTabularProductDataListDto>> {
    return salesTabularProductsDataUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsDataUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesTabularProductsDataUpdate$FormData(
    params: SalesTabularProductsDataUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedTabularProductDataListDto> {
    return this.salesTabularProductsDataUpdate$FormData$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendPaginatedTabularProductDataListDto>): BackendPaginatedTabularProductDataListDto =>
          r.body,
      ),
    );
  }

  /** Path part for operation `salesTabularProductsRetrieve()` */
  static readonly SalesTabularProductsRetrievePath = '/api/sales/tabular-products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesTabularProductsRetrieve$Response(
    params: SalesTabularProductsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTabularProductDto>> {
    return salesTabularProductsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesTabularProductsRetrieve(
    params: SalesTabularProductsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendTabularProductDto> {
    return this.salesTabularProductsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTabularProductDto>): BackendTabularProductDto => r.body),
    );
  }

  /** Path part for operation `salesTabularProductsUpdate()` */
  static readonly SalesTabularProductsUpdatePath = '/api/sales/tabular-products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesTabularProductsUpdate$Response(
    params: SalesTabularProductsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTabularProductDto>> {
    return salesTabularProductsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesTabularProductsUpdate(
    params: SalesTabularProductsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendTabularProductDto> {
    return this.salesTabularProductsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTabularProductDto>): BackendTabularProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesTabularProductsUpdate$XWwwFormUrlencoded$Response(
    params: SalesTabularProductsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTabularProductDto>> {
    return salesTabularProductsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesTabularProductsUpdate$XWwwFormUrlencoded(
    params: SalesTabularProductsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTabularProductDto> {
    return this.salesTabularProductsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTabularProductDto>): BackendTabularProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesTabularProductsUpdate$FormData$Response(
    params: SalesTabularProductsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTabularProductDto>> {
    return salesTabularProductsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesTabularProductsUpdate$FormData(
    params: SalesTabularProductsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTabularProductDto> {
    return this.salesTabularProductsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTabularProductDto>): BackendTabularProductDto => r.body),
    );
  }

  /** Path part for operation `salesTabularProductsDestroy()` */
  static readonly SalesTabularProductsDestroyPath = '/api/sales/tabular-products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesTabularProductsDestroy$Response(
    params: SalesTabularProductsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return salesTabularProductsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesTabularProductsDestroy(params: SalesTabularProductsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.salesTabularProductsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `salesTabularProductsPartialUpdate()` */
  static readonly SalesTabularProductsPartialUpdatePath = '/api/sales/tabular-products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesTabularProductsPartialUpdate$Response(
    params: SalesTabularProductsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTabularProductDto>> {
    return salesTabularProductsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesTabularProductsPartialUpdate(
    params: SalesTabularProductsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendTabularProductDto> {
    return this.salesTabularProductsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTabularProductDto>): BackendTabularProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesTabularProductsPartialUpdate$XWwwFormUrlencoded$Response(
    params: SalesTabularProductsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTabularProductDto>> {
    return salesTabularProductsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesTabularProductsPartialUpdate$XWwwFormUrlencoded(
    params: SalesTabularProductsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTabularProductDto> {
    return this.salesTabularProductsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTabularProductDto>): BackendTabularProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesTabularProductsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesTabularProductsPartialUpdate$FormData$Response(
    params: SalesTabularProductsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTabularProductDto>> {
    return salesTabularProductsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesTabularProductsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesTabularProductsPartialUpdate$FormData(
    params: SalesTabularProductsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTabularProductDto> {
    return this.salesTabularProductsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTabularProductDto>): BackendTabularProductDto => r.body),
    );
  }

  /** Path part for operation `salesUnblockProductsVariantsCreate()` */
  static readonly SalesUnblockProductsVariantsCreatePath = '/api/sales/unblock-products-variants/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesUnblockProductsVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesUnblockProductsVariantsCreate$Response(
    params: SalesUnblockProductsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return salesUnblockProductsVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesUnblockProductsVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesUnblockProductsVariantsCreate(
    params: SalesUnblockProductsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.salesUnblockProductsVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesUnblockProductsVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesUnblockProductsVariantsCreate$XWwwFormUrlencoded$Response(
    params: SalesUnblockProductsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return salesUnblockProductsVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesUnblockProductsVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesUnblockProductsVariantsCreate$XWwwFormUrlencoded(
    params: SalesUnblockProductsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.salesUnblockProductsVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesUnblockProductsVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesUnblockProductsVariantsCreate$FormData$Response(
    params: SalesUnblockProductsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return salesUnblockProductsVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesUnblockProductsVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesUnblockProductsVariantsCreate$FormData(
    params: SalesUnblockProductsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.salesUnblockProductsVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }
}
